import React from 'react';
import PropTypes from 'prop-types';

const NewspartnersLayout = (props) => {
  return <div className="newspartners story-content">{props.children}</div>;
};

NewspartnersLayout.propTypes = {
  children: PropTypes.node,
};

export default NewspartnersLayout;
